
import AddCircleIcon from '@mui/icons-material/AddCircle';
import { Avatar, Paper, Table, TableBody, TableCell, TableFooter, TableHead, TablePagination, TableRow, TableSortLabel, Tooltip } from '@mui/material';
import { getUserFullName, highlightText } from 'app/utils/appHelpers';
import { useEffect, useState } from 'react';
import { useTemplateFontSettings } from "styles/templateFontSettings";
import config from '../../../../config';
import UserParticipantDataTableToolbar from './UserParticipantDataTableToolbar';


function UserParticipantDataTable({ mainData = [], addMember, componentType }) {

  const [data, setData] = useState([]);
  const [data2, setData2] = useState([]);

  const [order, setOrder] = useState("asc");
  const [orderBy, setOrderBy] = useState();
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [highlightQuery, setHighlightQuery] = useState('');


  useEffect(() => {
    setData(mainData);
    setData2(mainData);
  }, [mainData])

  const updateAfterTable = (item) => {
    let tmp = data;
    const index = data.findIndex(x => x.id === item.id);
    index !== -1 ? tmp[index] = item : tmp.push({ ...item, id: Number(data[data.length - 1].id) + 1 })
    setData([...tmp]);
    setData2([...tmp]);
  }

  const column = [
    { id: 'title', align: 'center', disablePadding: true, label: 'Ünvan Ad Soyad' },
    { id: 'islemler', align: 'left', disablePadding: false, label: 'İşlemler' } // Align 'İşlemler' to the left
  ];


  const handleRequestSort = (event, property) => {

    const tempOrderBy = property;
    let tempOrder = 'desc';

    if (orderBy === property && order === 'desc') {
      tempOrder = 'asc';
    }
    const tempdata =
      tempOrder === 'desc'
        ? data.sort((a, b) => (b[tempOrderBy] < a[tempOrderBy] ? -1 : 1))
        : data.sort((a, b) => (a[tempOrderBy] < b[tempOrderBy] ? -1 : 1));


    setData(tempdata);
    setOrder(tempOrder);
    setOrderBy(tempOrderBy);

  };


  const DataTableHead = ({ onRequestSort, customColumnData }) => {

    const createSortHandler = property => event => {
      onRequestSort(event, property);
    };

    return (
      <TableHead>
        <TableRow>
          {customColumnData.map(column => {
            return (
              <TableCell
                key={column.id}
                align={column.numeric}
                padding={column.disablePadding ? 'none' : 'normal'}
              >
                <Tooltip
                  title="Sırala"
                  placement={column.numeric ? 'bottom-end' : 'bottom-start'}
                  enterDelay={300}
                >
                  <TableSortLabel
                    active={orderBy === column.id}
                    direction={order}
                    onClick={createSortHandler(column.id)}
                  >
                    {column.label}
                  </TableSortLabel>
                </Tooltip>
              </TableCell>
            );
          }, this)}
        </TableRow>
      </TableHead>
    );
  };

  const { baseFontSize, iconFontSize, fabStyle } = useTemplateFontSettings()



  return (
    <Paper className="col-md-12">
      <UserParticipantDataTableToolbar
        pageTitle={componentType === "user" ? "Üye Rolü Bulunanlar" : "Katılımcı Rolü Bulunanlar"}
        data2={data2}
        setData={setData}
        afterUpdateFunc={updateAfterTable}
        addAfterTable={(x) => setData([x, ...data2])}
        setHighlightQuery={setHighlightQuery}
      />

      <div className="flex-auto">
        <div className="table-responsive-material">
          <Table size="small" >
            <DataTableHead
              order={order}
              orderBy={orderBy}
              onRequestSort={handleRequestSort}
              rowCount={data.length}
              customColumnData={column}
            />
            <TableBody>
              {data.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map(n => {

                return (

                  <TableRow hover key={"trO" + n.id}>

                    <TableCell align="center" padding="normal" style={{ display: 'flex', alignItems: 'center', height: '50px' }}>
                      <Avatar
                        alt={n.name} src={n && n.profileImageUrl
                          ? `${config.userAuthApiUrl}${n.profileImageUrl}`
                          : undefined}
                        sx={{ ...fabStyle }}
                        onError={(e) => { e.target.onerror = null; e.target.src = config.userAuthApiUrl + config.defaultProfileImageUrl }}
                      />
                      <span style={{ fontSize: baseFontSize, marginLeft: '10px' }}>{highlightText(getUserFullName(n), highlightQuery)}</span>
                    </TableCell>

                    <TableCell align="left" padding="normal"> {/* Align 'İşlemler' to the left */}
                      <Tooltip title="Ekle">
                        <AddCircleIcon
                          sx={{
                            fontSize: iconFontSize,
                            cursor: 'pointer',
                            color: 'primary.main',
                            marginLeft: '18px',
                          }}
                          onClick={() => addMember(n)}
                        />
                      </Tooltip>
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
            <TableFooter>
              <TableRow>
                <TablePagination
                  count={data.length}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  onPageChange={(e, page) => setPage(page)}
                  onRowsPerPageChange={(e) => setRowsPerPage(Number(e.target.value))}
                  labelRowsPerPage={"Görüntülenecek Satır"}
                  rowsPerPageOptions={[10, 50, 100, { label: "Tümü", value: -1 }]}
                  showFirstButton
                  showLastButton
                />
              </TableRow>
            </TableFooter>
          </Table>
        </div>
      </div>



    </Paper >
  )
}

export default UserParticipantDataTable